import bdServices125 from './bd-services125'
import bdServices from './bd-services'
var FormData = require('form-data')

const ductosServices = {}

ductosServices.getEB00 = async function () {
  const data = bdServices.get('servidores/ducto/data/patinPM100.php')
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

ductosServices.getValvulas = async function () {
  const data = bdServices.get('servidores/ducto/data/valvulas.php')
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

ductosServices.getCheckList_Items = async function (plano) {
  const data = bdServices.get(`servidores/ducto/data/get_Items_Valvulas.php?plano=${plano}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

ductosServices.getCheckList_valores = async function (idValv) {
  const data = bdServices.get(`servidores/ducto/data/getValvulas_Valores.php?id=${idValv}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

ductosServices.getCheckList_valoresUlt = async function (idValv) {
  const data = bdServices.get(`servidores/ducto/data/getValvulas_ValoresUlt.php?id=${idValv}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

ductosServices.add_Checklist = async function (id, fechaReg, id_usuario, usuario, id_valvula, item1, item2, item3_a, item3_b, item4_a, item4_b, item4_c, item4_d, item5_a, item5_b, item5_c, item5_d, item5_e, item7_a, item7_b, item8, item9, item10, item11, item12, item13, item14, item15, item16_a, item16_b, item17_a, item17_b, item18) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('fechaReg', fechaReg)
  formData.append('id_usuario', id_usuario)
  formData.append('usuario', usuario)
  formData.append('id_valvula', id_valvula)
  formData.append('item1', item1)
  formData.append('item2', item2)
  formData.append('item3_a', item3_a)
  formData.append('item3_b', item3_b)
  formData.append('item4_a', item4_a)
  formData.append('item4_b', item4_b)
  formData.append('item4_c', item4_c)
  formData.append('item4_d', item4_d)
  formData.append('item5_a', item5_a)
  formData.append('item5_b', item5_b)
  formData.append('item5_c', item5_c)
  formData.append('item5_d', item5_d)
  formData.append('item5_e', item5_e)
  formData.append('item7_a', item7_a)
  formData.append('item7_b', item7_b)
  formData.append('item8', item8)
  formData.append('item9', item9)
  formData.append('item10', item10)
  formData.append('item11', item11)
  formData.append('item12', item12)
  formData.append('item13', item13)
  formData.append('item14', item14)
  formData.append('item15', item15)
  formData.append('item16_a', item16_a)
  formData.append('item16_b', item16_b)
  formData.append('item17_a', item17_a)
  formData.append('item17_b', item17_b)
  formData.append('item18', item18)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/ducto/data/add_checklist.php'
  }
  
  const data = bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

ductosServices.getProductoEnviado = async function (fechaI, fechaF) {
  const data = bdServices.get(`/servidores/ducto/data/getProductoEnviado.php?fI=${fechaI}&fF=${fechaF}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

ductosServices.getPatinEB04 = async function () {
  const data = bdServices.get('servidores/ducto/data/patinEB04.php')
    .then(res => res.data)
    .catch(e => console.log(e))
  return data

}

ductosServices.getValvulas_fecha = async function (fecha_ini, fecha_fin) {
  let formData = new FormData()
  formData.append('fecha_ini', fecha_ini)
  formData.append('fecha_fin', fecha_fin)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/ducto/data/valvulas_date.php'
  }
  
  const data = bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

ductosServices.getValvulas_fecha_bis = async function (fecha_ini, fecha_fin) {
  let formData = new FormData()
  formData.append('fecha_ini', fecha_ini)
  formData.append('fecha_fin', fecha_fin)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/ducto/data/valvulas_bis_date.php'
  }
  
  const data = bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

export default ductosServices


// WEBPACK FOOTER //
// ./src/services/ducto.js